module.exports = __webpack_public_path__ + "img/矢印アイコン右4.99f0343c.svg";